var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"fixed top-0 bottom-0 left-0 right-0 bg-black/25 flex items-center justify-center z-500 z-1000 bg-white/80",attrs:{"data-test":"loadingBlockUI"}},[_c('svg-icon',{staticClass:"iconSize-48 text-goPink animate-loader",attrs:{"name":"loader"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }